import { IconPropType } from ".";

export const ClockIcon: React.FC<IconPropType> = ({ width = 20, height = 20, className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" className={className}>
  <g clipPath="url(#clip0_2508_256)">
    <path d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1Z" fill="currentColor"/>
    <path d="M10.5 3C10.2239 3 10 3.22386 10 3.5V10.5H4.5C4.22386 10.5 4 10.7239 4 11C4 11.2761 4.22386 11.5 4.5 11.5H10.5C10.7761 11.5 11 11.2761 11 11V3.5C11 3.22386 10.7761 3 10.5 3Z" fill="currentColor"/>
  </g>
  <defs>
    <clipPath id="clip0_2508_256">
      <rect width="20" height="20" fill="white"/>
    </clipPath>
  </defs>
</svg>
);